import { useEffect, useRef, useState } from "react";
import "./index.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BeatLoader, ClipLoader } from "react-spinners";
import { faMicrophone } from "@fortawesome/free-solid-svg-icons/faMicrophone";
import { RecordRTCPromisesHandler, StereoAudioRecorder } from "recordrtc";
import {
  faHeadphones,
  faVolumeHigh,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Harker } from 'hark';
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { text } from "@fortawesome/fontawesome-svg-core";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const Chat = ({
  response,
  readyToAnswer,
  setReady,
  fetchWithRetries,
  setSubmittedName,
  isLoading,
  setIsLoading,
  setCanvasElementShow,
  setVideoElementShow,
  setTextExpressionElementShow,
  language,
  readyRepeat,
  setReadyRepeat,
  topic,
  token,
  setShowTranscript,
  showTranscript,
  avatar,
  setSubmitted,
  pushMessage,
  isSubmitted,
  messages,
  chatList,
  transcriptChatList,
  transcriptList,
  handleSendMessage,
  setIsImage,
  setURL,
  setVideoURL,
  setExpression,
  talkURL,
  setTalkURL,
  avatarName,
  setVoiceConnection,
  origin
}) => {
  const [input, setInput] = useState("");

  const [isFirstVisit, setFirstVisit] = useState(true);
  const [name, setName] = useState("");

  const [prevPrompt, setPrevPrompt] = useState("");
  const [prevResp, setPrevResp] = useState("");
  const [isTalk, setTalk] = useState();
  const [talkPaused, setTalkPaused] = useState(false);
  const talkStatus = useRef();
  const [talkCommand, setTalkCommand] = useState("Tap to start talk");
  const [talkScript, setTalkScript] = useState({});
  const [aiResponse, setAIResponse] = useState("");
  const [source, setSource] = useState();
  const [allowMic, setAllowMic] = useState()

  const [showPopup, setShowPopup] = useState(false);
  const [popupURL, setPopupURL] = useState();

  const [isPopupImage, setIsPopupImage] = useState();

  const [fullAiResponse, setFullAiResponse] = useState();
  const recorder = useRef();
  const stream = useRef();
  const listener = useRef();
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();
  const currentTranscript = useRef()

  let timeoutID = "";

  const handleKeyDown = (event) => {
    if (event.key == "Enter") {
      handleSendMessage(event.target.value);
      setInput("");
    }
  };

  const handleSubmit = () => {
    if(input.split(" ").join("") !== ""){
      handleSendMessage(input);
    }
    setInput("")
  };

  function get_url_extension(url) {
    return url.split(/[#?]/)[0].split(".").pop().trim();
  }

  async function talkToOpenAI(prompt) {
    let formData = new FormData();
    formData.append("prompt", prompt);
    formData.append(
      "chat_history",
      `[{"user": "${prevPrompt}"},{"ai": "${prevResp}"}]`
    );
    formData.append("use_audio", "true");
    formData.append("use_dall_e", "false");
    formData.append("use_expression", "false");

    const openAI = await fetchWithRetries(
      `${process.env.REACT_APP_FXAI_SERVER_URL}/api/chat?app_id=1&passphrase=${topic}&config_id=${avatar}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formData,
      }
    );
    if (response.status === 500) {
      console.error("Server error");
      language === "english"
        ? pushMessage(
            "AI",
            "I apologize, but it seems there is an issue with the system. Please try reloading the page or contact our support team at monika@fxmweb.com.",
            "assistant",
            null,
            "I apologize, but it seems there is an issue with the system. Please try reloading the page or contact our support team at monika@fxmweb.com."
          )
        : pushMessage(
            "AI",
            "Maaf, sepertinya ada sedikit masalah dengan sistem. Coba untuk memuat ulang halaman ini atau kontak tim kami melalui email monika@fxmweb.com.",
            "assistant",
            null,
            "Maaf, sepertinya ada sedikit masalah dengan sistem. Coba untuk memuat ulang halaman ini atau kontak tim kami melalui email monika@fxmweb.com."
          );
      throw new Error("Server error");
    } else {
      const data = await openAI.json();
      if (data && data.status == "OK") {
        setPrevPrompt(prompt);
        setPrevResp(data.data.text.replace(/\r/g, "").replace(/\n/g, ""));
        if(data.data.expression && data.data.expression.hyperlink){
          setVideoURL(process.env.REACT_APP_FXAI_SERVER_URL + data.data.expression.hyperlink.split("//").join("/"))
          setExpression(data.data.expression.expression)
        }
        else{
          setVideoURL(talkURL)
        }
        
        let response = data.data.text.replace(/"/g, "'");
        let url =
          response.split("[").length > 1
            ? data.data.text.split("[")[1].split("]")[0]
            : null;
        setURL(url);
        
        let text = response.replace(url, "").replace("]", "").replace("[", "");
        setFullAiResponse(response.replace("]", "").replace("[", ""));
        let imageFormat = url ? get_url_extension(url) : null;
        let isImage = imageFormat
        ? imageFormat === "png" ||
          imageFormat === "jpeg" ||
          imageFormat === "jpg" ||
          imageFormat === "svg"
          ? true
          : false
        : false
        setIsImage(isImage);
        setAIResponse(text);
        setTalkScript({text:text, url: url, format: isImage})
        setSource(data.data.source);
        setReady(true);
        document.getElementById("vo").src =
          process.env.REACT_APP_FXAI_SERVER_URL +
          data.data.audioHyperlink.split("//").join("/");
        document.getElementById("vo").play();
      } else {
        talkStatus.current = "SILENT";
        setTalkScript({})
        language === "english"
          ? setTalkCommand(
              "Sorry, we cannot hear your question clearly. Please tap and repeat your question"
            )
          : setTalkCommand(
              "Maaf, kami tidak dapat mendengar pertanyaanmu dengan jelas. Tolong tekan tombol dan ulangi pertanyaanmu"
            );
        setIsLoading(false);
        language === "english"
          ? pushMessage(
              "AI",
              "I apologize, but it seems there is an issue with the system. Please try reloading the page or contact our support team at monika@fxmweb.com.",
              "assistant",
              null,
              "I apologize, but it seems there is an issue with the system. Please try reloading the page or contact our support team at monika@fxmweb.com."
            )
          : pushMessage(
              "AI",
              "Maaf, sepertinya ada sedikit masalah dengan sistem. Coba untuk memuat ulang halaman ini atau kontak tim kami melalui email monika@fxmweb.com.",
              "assistant",
              null,
              "Maaf, sepertinya ada sedikit masalah dengan sistem. Coba untuk memuat ulang halaman ini atau kontak tim kami melalui email monika@fxmweb.com."
            );
      }
    }
  }

  const convertToCSV = (objArray) => {
    const array =
      typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
    let str = "";

    for (let i = 0; i < array.length; i++) {
      let line = "";
      for (let index in array[i]) {
        if (line !== "") line += ",";

        line += array[i][index].split(",").join(" ");
      }
      str += line + "\r\n";
    }
    return str;
  };

  const downloadCSV = () => {
    const csvData = new Blob([convertToCSV(transcriptList)], {
      type: "text/csv",
    });
    const csvURL = URL.createObjectURL(csvData);
    const link = document.createElement("a");
    link.href = csvURL;
    link.download = `transcript_${new Date()
      .toLocaleDateString()
      .split("/")
      .join("")}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadPdf = () => {
    let document = [];
    transcriptList.forEach((data) => {
      document.push(data.Name + " : " + data.Message);
    });
    pdfMake.createPdf({ content: document }).download();
  };

  async function speechToText(blob) {
    setIsLoading(true);
    const file = new File([blob], "speech.mp3", {
      type: "audio/mpeg",
    });
    const formData = new FormData();
    formData.append("file", file);
    formData.append("model", "whisper-1");
    formData.append("language", language === "english" ? "en" : "id");
    const openAI = await fetchWithRetries(
      `${process.env.REACT_APP_OPENAI_SERVER_URL}/v1/audio/transcriptions`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_OPENAI_KEY}`,
        },
        body: formData,
      }
    );
    var response = await openAI.json();
    setIsLoading(false);
    if (response.error) {
      // recorder.current.startRecording();
      talkStatus.current = "SILENT";
      setVoiceConnection(false)
      setTalkScript({})
      language === "english"
        ? setTalkCommand(
            "I cannot hear you clearly. Please repeat your question"
          )
        : setTalkCommand(
            "Saya tidak dapat mendengarmu dengan jelas. Tolong ulangi pertanyaanmu"
          );
    } else {
      if (response.text) {
        handleSendMessage(response.text);
        setVoiceConnection(true)
      } else {
        await recorder.current.stopRecording();
        talkStatus.current = "SILENT";
        setVoiceConnection(false);
        // recorder.current.startRecording();
        setTalkScript({})
        language === "english"
          ? setTalkCommand(
              "I cannot hear you clearly. Please repeat your question"
            )
          : setTalkCommand(
              "Saya tidak dapat mendengarmu dengan jelas. Tolong ulangi pertanyaanmu"
            );
      }
    }
  }

  async function talkInit() {
    stream.current = await navigator.mediaDevices.getUserMedia({ audio: true });
    recorder.current = new RecordRTCPromisesHandler(stream.current, {
      mimeType: "audio/wav",
      numberOfAudioChannels: 1, // mono
      recorderType: StereoAudioRecorder,
      sampleRate: 44100, // Sample rate = 44.1khz
      type: "audio",
    });
    checkMicrophonePermission()
    // if (!listener.current) {
    //   const { default: hark } = await import('hark')
    //   listener.current = hark(stream.current, {
    //     interval: 100,
    //     play: false,
    //   })

    //   listener.current.off('speaking', onStartSpeaking)
    //   listener.current.off('stopped_speaking', onStopSpeaking)
    // }

    
  }

  // const onStartSpeaking = () => {
  //   console.log('start speaking')
    
  // }

  // const onStopSpeaking = () => {
  //   console.log('stop speaking')
   
  // }

  const handleCheckPermission = () => {
    checkMicrophonePermission()
    language === "english"
      ? setTalkCommand("Please allow microphone access for a better experience.")
      : setTalkCommand("Izinkan akses mikrofon untuk pengalaman lebih baik.");
  }

  const handleInitTalk = async () => {
    talkInit()
    setTalk(true)
    language === "english"
      ? setTalkCommand("Tap to start talk")
      : setTalkCommand("Tekan untuk mulai berbicara...");
    
  }

  const handleSwitchTalkSubmit = () => {
    if (talkStatus.current == "LISTEN") {
      handleSubmitTalk();
    } else if (talkStatus.current == "SILENT") {
      handleStartListening();
    }
  };

  const handleStartListening = async () => {
    setTalkScript({})
    language === "english"
      ? setTalkCommand("Tap after finishing talking")
      : setTalkCommand("Tekan jika sudah selesai berbicara...");
    
    await talkInit();
    const recordState = await recorder.current.getState();
    console.log(recordState);
    if(language === "english"){
      resetTranscript();
      currentTranscript.current = ""
    }else{
      if (recordState === "inactive" || recordState === "stopped") {
        await recorder.current.startRecording();
      }
      
    }
    
    talkStatus.current = "LISTEN";
    console.log(timeoutID)
    timeoutID = setTimeout(() => {
      handleTimeoutSubmitTalk()
    },20000)
  };

  const handleSubmitTalk = async () => {
    if(transcript !== ""){
      if(language === "english"){
        setIsLoading(true)
        handleSendMessage(transcript);
        resetTranscript();
      }else{
        await recorder.current.stopRecording();
        const blob = await recorder.current.getBlob();
        speechToText(blob);
        stream.current?.getTracks().forEach((track) => {
          track.stop();
        });
        await recorder.current.destroy();
      }
     
      setTalkScript({})
      language === "english"
        ? setTalkCommand("Thinking...")
        : setTalkCommand("Berfikir...");
      talkStatus.current = "THINK";
      clearTimeout(timeoutID)
    }else{
      // recorder.current.startRecording();
      talkStatus.current = "SILENT";
      setVoiceConnection(true)
      setTalkScript({})
      language === "english"
        ? setTalkCommand(
            "I cannot hear you clearly. Please repeat your question"
          )
        : setTalkCommand(
            "Saya tidak dapat mendengarmu dengan jelas. Tolong ulangi pertanyaanmu"
          );
    }
    
  };

  const handleTimeoutSubmitTalk = async () => {
    if(currentTranscript.current !== ""){
      if(talkStatus.current === "LISTEN") {
        if(language === "english"){
          setIsLoading(true)
          handleSendMessage(currentTranscript.current);
          resetTranscript();
        }else{
          await recorder.current.stopRecording();
          const blob = await recorder.current.getBlob();
          speechToText(blob);
          stream.current?.getTracks().forEach((track) => {
            track.stop();
          });
          await recorder.current.destroy();
        }
       
        setTalkScript({})
        language === "english"
          ? setTalkCommand("Thinking...")
          : setTalkCommand("Berfikir...");
        talkStatus.current = "THINK";
        clearTimeout(timeoutID)
      }
    }else{
      // recorder.current.startRecording();
      talkStatus.current = "SILENT";
      setVoiceConnection(true)
      setTalkScript({})
      language === "english"
        ? setTalkCommand(
            "I cannot hear you clearly. Please repeat your question"
          )
        : setTalkCommand(
            "Saya tidak dapat mendengarmu dengan jelas. Tolong ulangi pertanyaanmu"
          );
    }
    
    
  };

  const handleExitTalk = () => {
    
    if(language === "english"){
      // eslint-disable-next-line no-restricted-globals
      if(confirm("Are you sure you want to exit?")){
        setTalk(false);
        
        if(language === "english"){
          resetTranscript();
          SpeechRecognition.abortListening();
          SpeechRecognition.stopListening();
        }else{
          recorder.current.stopRecording();
        }
        setTalkScript({})
        talkStatus.current = "SILENT";
        clearTimeout(timeoutID)
      }
    }else{
      // eslint-disable-next-line no-restricted-globals
      if(confirm("Apakah kamu yakin mau keluar?")){
        setTalk(false);
        recorder.current.stopRecording();
        setTalkScript({})
        talkStatus.current = "SILENT";
        clearTimeout(timeoutID)
      }
    }
  };

  const handleClickPopup = (link, isImage) => {
    setPopupURL(link);
    setShowPopup(true);
    setIsPopupImage(isImage);
  };

  const handleClosePopup = () => {
    setPopupURL();
    setShowPopup(false);
  };

  const checkMicrophonePermission = async () => {
    try {
      // Check for microphone permission status
      const permission = await navigator.permissions.query({ name: 'microphone' });
      console.log(permission.state)
      if (permission.state === 'granted') {
        setAllowMic(true); // Permission granted
        SpeechRecognition.startListening({ continuous: true });
      } else if (permission.state === 'denied') {
        setAllowMic(false); // Permission denied
        setVoiceConnection(false)
      } else {
        // Request microphone access
        try {
          await navigator.mediaDevices.getUserMedia({ audio: true });
          setAllowMic(true); // Permission granted after request
          SpeechRecognition.startListening({ continuous: true });
        } catch (err) {
          setAllowMic(false); // Permission denied after request
          setVoiceConnection(false)
        }
      }

      // Listen for permission changes
      permission.onchange = () => {
        console.log(permission.state)
        setAllowMic(permission.state === 'granted');
        if(permission.state === "denied"){
          language === "english"
          ? setTalkCommand("Please allow microphone access for a better experience.")
          : setTalkCommand("Izinkan akses mikrofon untuk pengalaman lebih baik.");
        }
       
      };
    } catch (error) {
      setAllowMic(false); // Set false in case of an error
      setVoiceConnection(false)
    }
  };

  useEffect(() => {
    if (readyToAnswer) {
      setIsLoading(false);
      setSubmitted(false);
      pushMessage("AI", aiResponse, "assistant", source, fullAiResponse);
      setReady(false);
      setTalkCommand();
      talkStatus.current = "RESPOND";
    }
  }, [readyToAnswer]);

  useEffect(() => {
    if (readyRepeat) {
      setIsLoading(false);
      setSubmitted(false);
      pushMessage(
        "AI",
        response.split("-").join(""),
        "assistant",
        null,
        response.split("-").join("")
      );
      setReadyRepeat(false);
      setTalkCommand();
      
      talkStatus.current = "RESPOND";
    }
  }, [readyRepeat]);

  useEffect(() => {
    if (isSubmitted) {
      talkToOpenAI(messages);
    }
  }, [messages]);

  useEffect(() => {
    if (!isTalk) {
      var elem = document.getElementsByClassName("chat-body");
      elem[0].scrollTo(0, elem[0].scrollHeight);
    }
  }, [chatList, isLoading]);

  useEffect(() => {
    document.getElementById("vo").pause();
  }, [avatar]);

  useEffect(() => {
    talkInit();
    setTalkScript({})
    talkStatus.current = "SILENT";
    language === "english"
      ? setTalkCommand("Tap to start talk")
      : setTalkCommand("Tekan untuk mulai berbicara...");
    document.getElementById("vo").load();
    document.getElementById("vo").addEventListener("canplaythrough", () => {
      console.log("loaded audio");
    });
    document.getElementById("vo").onplay = function () {
      setCanvasElementShow(false);
      setVideoElementShow(true);
      setTextExpressionElementShow(false)
    };

    document.getElementById("vo").onpause = function () {
      setCanvasElementShow(true);
      setVideoElementShow(false);
      setTextExpressionElementShow(false)
      console.log(talkURL)
      setVideoURL(talkURL)
      talkStatus.current = "SILENT";
      setTalkScript({})
      language === "english"
        ? setTalkCommand("Tap to start talk")
        : setTalkCommand("Tekan untuk mulai berbicara...");
    };

    
  }, [talkURL]);

  useEffect(() => {
   
    if(talkStatus.current === "SILENT"){
      language === "english"
      ? setTalkCommand("Tap to start talk")
      : setTalkCommand("Tekan untuk mulai berbicara...");
      
    }else if(talkStatus.current === "LISTEN"){
      language === "english"
      ? setTalkCommand("Tap after finishing talking")
      : setTalkCommand("Tekan jika sudah selesai berbicara...");
    }
  }, [language])

  

  // useEffect(() => {
    
  //   if (listener.current) {
  //     console.log(listener.current)
  //     listener.current.off('speaking', onStartSpeaking)
  //     listener.current.off('stopped_speaking', onStopSpeaking)
  //   }
  // }, [listener.current])

  useEffect(() => {

    if(talkStatus.current === "LISTEN" && language === "english"){
      setTalkScript({text: transcript})
      currentTranscript.current = transcript
    }
  }, [transcript])

  return (
    <>
      {isTalk ? (
        <div className="talk">
          <div className="talk-script">
            {talkScript.text}
            {talkScript.url ? 
          <div className="talk-script_button" onClick={() => handleClickPopup(talkScript.url, talkScript.format)}>View Details</div>: 
          <></>}
          </div>
          
          <div className="talk-command">{talkCommand}</div>
          <div className="details">
            <div className="talk-start_container">
              {allowMic ? 
              <button
              className={`talk-start ${talkStatus.current} ${origin}`}
              onClick={() => handleSwitchTalkSubmit()}
            >
              {talkStatus.current === "THINK" ? (
                <ClipLoader size={24} color="#fff" />
              ) : (
                <FontAwesomeIcon
                  icon={
                    talkStatus.current === "SILENT" ? (
                      faMicrophone
                    ) : talkStatus.current === "RESPOND" ? (
                      faVolumeHigh
                    ) : talkStatus.current === "THINK" ? (
                      <></>
                    ) : (
                      faMicrophone
                    )
                  }
                />
              )}
              </button> : 
              <button
              className={`talk-start SILENT `}
              onClick={() => handleCheckPermission()}
            >
             <FontAwesomeIcon
                  icon={faMicrophone}
                />
            </button>
            }
              
            </div>
            <button className="talk-close" onClick={() => handleExitTalk()}>
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
        </div>
      ) : (
        <div className={`chat ${avatarName}`}>
          <div className="chat-body">

            {chatList.map((chat) => (
              <div
                className={`chat-item ${origin} ${chat.type == "AI" ? "ai" : "human"}`}
              >
                <div className="chat-detail">
                  <span className="chat-name">{chat.recipient}</span>
                  <div className="chat-bubble">
                    <Markdown remarkPlugins={[remarkGfm]}>
                      {chat.message}
                    </Markdown>

                  </div>
                  {chat.url ? (
                    <div
                      className="chat-button"
                      onClick={() => handleClickPopup(chat.url, chat.format)}
                    >
                      View Detail
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            ))}
            {isLoading ? (
              <div className={`chat-item ai`}>
                <div className="chat-detail">
                  <span className="chat-name"></span>
                  <div className="chat-bubble loading">
                    <BeatLoader color="#fff" />
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className={`chat-field ${origin}`}>
            <button className="mic" onClick={() => handleInitTalk()}>
              <FontAwesomeIcon icon={faMicrophone} />
            </button>
            <div className="chat-field_container">
              <div className="chat-field_top">
                <input
                  placeholder={
                    language === "english" ? "Type a message..." : "Ketik pesan..."
                  }
                  value={input}
                  
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={(e) => handleKeyDown(e)}
                />
                <button className="send-chat" onClick={() => handleSubmit()}>
                  {origin === "hospital" ? <img src={`${process.env.PUBLIC_URL}/assets/hospital_submit.svg`}></img> : origin === "classroom" ? <img src={`${process.env.PUBLIC_URL}/assets/classroom_submit.svg`}></img> : <img src={`${process.env.PUBLIC_URL}/assets/send.svg`}></img>}
                  
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={`transcript ${showTranscript ? "show" : "hide"} ${origin}`}>
        <div className="transcript-header">
          {language === "english" ? "CHAT TRANSCRIPT" : "TRANSKRIP PESAN"}
          <FontAwesomeIcon
            icon={faXmark}
            onClick={() => setShowTranscript(false)}
          />
        </div>
        <div className="transcript-body">
          {transcriptChatList.map((chat) => (
            <div className={`chat-item ${chat.type == "AI" ? "ai" : "human"} ${origin}`}>
              <div className="chat-detail">
                <span className="chat-name">{chat.recipient}</span>
                <div className="chat-bubble">{chat.message}</div>
              </div>
            </div>
          ))}
        </div>
        <div className={`transcript-footer ${origin}`}>
          <button onClick={downloadCSV}>DOWNLOAD CSV</button>
          <button onClick={downloadPdf}>DOWNLOAD PDF</button>
        </div>
      </div>
      <div className={`popup ${showPopup ? "show" : "hide"}`}>
        <div className="popup-header">
          <FontAwesomeIcon icon={faXmark} onClick={() => handleClosePopup()} />
        </div>
        <div className="popup-body">
          <div className="popup-loading">
            <ClipLoader color="#fff" />
          </div>
          {isPopupImage ? (
            <img className="popup-image" src={popupURL} />
          ) : (
            <iframe
              name="iframe1"
              className="popup-iframe"
              src={popupURL}
              align="center"
              frameborder="1"
              vspace="0"
            />
          )}
        </div>
      </div>
      <audio id="vo" src=""></audio>
    </>
  );
};

export default Chat;
